import React from 'react';

import { Link } from 'gatsby';
import * as Yup from 'yup';
import { withFormik } from 'formik';

import { InputGroup, TextArea, Button, Heading } from '../elements';

const QuoteForm = ({
  values,
  touched,
  errors,
  handleSubmit,
  handleChange,
  handleBlur,
  isSubmitting,
}) => {
  return (
    <>
      <Heading className="is-2">Get a FREE Quote</Heading>
      <form onSubmit={handleSubmit}>
        <InputGroup
          name="name"
          placeholder="Enter your full name"
          type="text"
          value={values.name}
          onChange={handleChange}
          onBlur={handleBlur}
          errors={errors.name && touched.name ? errors.name : undefined}
        />
        <InputGroup
          name="email"
          placeholder="Enter your email address"
          type="text"
          value={values.email}
          onChange={handleChange}
          onBlur={handleBlur}
          errors={errors.email && touched.email ? errors.email : undefined}
        />
        <InputGroup
          placeholder="Enter your contact phone number"
          name="telephone"
          type="text"
          value={values.telephone}
          onChange={handleChange}
          onBlur={handleBlur}
          errors={
            errors.telephone && touched.telephone ? errors.telephone : undefined
          }
        />
        <TextArea
          rows={4}
          placeholder="Details of query"
          name="message"
          type="text"
          value={values.message}
          onChange={handleChange}
          onBlur={handleBlur}
          errors={
            errors.message && touched.message ? errors.message : undefined
          }
        />
        <p className="is-size-7 has-text-white pb-3">
          By submitting you thereby agree to our {'  '}
          <Link className="has-text-orange" to="/terms-and-conditions">
            terms and conditions.
          </Link>
        </p>
        <Button
          disabled={isSubmitting}
          type="submit"
          className={`button is-dark has-text-white px-6 ${
            isSubmitting && 'is-loading'
          }`}
        >
          SEND
        </Button>
      </form>
    </>
  );
};

export default withFormik({
  mapPropsToValues: () => ({
    name: '',
    telephone: '',
    email: '',
    message: '',
  }),
  validationSchema: Yup.object().shape({
    name: Yup.string().required('Name is required!'),
    telephone: Yup.string().required('Phone number is required!'),
    email: Yup.string()
      .email('Invalid email address')
      .required('Email is required!'),
    message: Yup.string(),
  }),
  handleSubmit: (values, { setSubmitting, resetForm, props }) => {
    props
      .onSubmit({ ...values })
      .then(() => {
        setSubmitting(false);
        resetForm();
      })
      .catch(() => {
        setSubmitting(false);
      });
  },
  displayName: 'QuoteForm', // helps with React DevTools
})(QuoteForm);
